import { isString, sanitizeStringForUrl } from "@grandvisionhq/utils";
import { getUrl } from "../../../../../../../../utils/utils/get-url.js";
function createGraphSubCategoryBreadcrumb(categoryRoute, brand, page, variant) {
  let subCategoryProperty = brand;
  if (variant.variantType === "accessories") {
    subCategoryProperty = variant.accessoryType;
  }
  if (variant.variantType === "contact-lens" && variant.replacementFrequency) {
    subCategoryProperty = variant.replacementFrequency;
  }
  const categoryRoutePath = categoryRoute?.split("?")?.[0] ?? "";
  return isString(subCategoryProperty) && subCategoryProperty !== "" ? {
    name: subCategoryProperty,
    url: getUrl(
      `${categoryRoutePath}/${encodeURIComponent(sanitizeStringForUrl(subCategoryProperty))}`,
      page
    )
  } : null;
}
export {
  createGraphSubCategoryBreadcrumb
};
//# sourceMappingURL=create-graph-subcategory-breadcrumb.js.map
